var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuShoucang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11869 3.67641L6.73036 2.20304C7.94982 -0.734343 12.0502 -0.734343 13.2697 2.20302L13.8812 3.67635C14.1023 4.2088 14.5827 4.57414 15.1353 4.63677L16.8423 4.83021C19.8439 5.17036 21.0739 8.91073 18.8967 11.0174L17.4473 12.4199C17.0548 12.7996 16.8799 13.3639 16.9879 13.9107L17.3378 15.682C17.9496 18.7791 14.6077 21.1345 11.9612 19.434L10.8165 18.6985C10.3163 18.3771 9.68365 18.3771 9.18345 18.6985L8.03877 19.434C5.39236 21.1345 2.05038 18.7791 2.66219 15.682L3.0121 13.9107C3.12012 13.3639 2.94517 12.7997 2.55258 12.4198L1.10334 11.0175C-1.07395 8.91074 0.156107 5.17036 3.15773 4.83021L4.86465 4.63677C5.41734 4.57414 5.89766 4.20882 6.11869 3.67641ZM12.0341 4.44321L11.4225 2.9699C10.8856 1.6767 9.11437 1.6767 8.57751 2.96988L7.96584 4.44326C7.4676 5.64338 6.36875 6.47912 5.08986 6.62405L3.38294 6.81749C2.07333 6.9659 1.5227 8.64026 2.4941 9.58017L3.94331 10.9825C4.82516 11.8357 5.21334 13.0877 4.97419 14.2983L4.62428 16.0696C4.35023 17.4569 5.8123 18.4873 6.95763 17.7514L8.10232 17.0159C9.26114 16.2713 10.7388 16.2713 11.8977 17.0159L13.0424 17.7514C14.1877 18.4873 15.6498 17.4569 15.3758 16.0696L15.0259 14.2983C14.7867 13.0877 15.1748 11.8357 16.0566 10.9826L17.5059 9.58015C18.4773 8.64026 17.9267 6.9659 16.6171 6.81749L14.9101 6.62405C13.6313 6.47912 12.5325 5.64338 12.0341 4.44321Z",
    fill: "#091B3D",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuShoucang);
export default __webpack_public_path__ + "static/media/menu_shoucang.39e850389024335aa01c24462698c65b.svg";
export { ForwardRef as ReactComponent };